import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

import { styled } from '@mui/material/styles';

import WelcomeBanner from 'views/RentMyMotorcycleView/components/WelcomeBanner';
import HowRentingWorks from 'views/RentMyMotorcycleView/components/HowRentingWorks';
// import InsuranceInfo from 'views/RentMyMotorcycleView/components/InsuranceInfo';
import QuestionsSection from 'views/RentMyMotorcycleView/components/QuestionsSection';
import GotYourBack from 'views/RentMyMotorcycleView/components/GotYourBack';
import WhyEagleShare from 'views/RentMyMotorcycleView/components/WhyEagleShare';
import ReadyToEarn from 'views/RentMyMotorcycleView/components/ReadyToEarn';
import axios, { API } from 'lib/config/axios';
import Head from 'next/head';
import generateMetaData from 'lib/utils/generateMetaData';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';

const PREFIX = 'RentMyMoto';

const classes = {
  pageContainer: `${PREFIX}-pageContainer`,
  bannerContainer: `${PREFIX}-bannerContainer`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.pageContainer}`]: {
    backgroundColor: theme.palette.common.white,
    [theme.breakpoints.only('md')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
  },
  [`& .${classes.bannerContainer}`]: {
    backgroundColor: theme.palette.common.white,
    [theme.breakpoints.up('lg')]: {
      paddingTop: theme.spacing(14),
    },
  },
}));

const RentMyMotorcycleView = (props) => {
  const handleErrorResponse = useErrorsHandler();
  const { serverData } = props;
  const [seoValues, setSeoValues] = useState(serverData.seo_values);
  const getSeoValuesData = () => {
    axios
      .get(API.seoValues)
      .then((res) => {
        setSeoValues(res.data);
      })
      .catch((error) => {
        handleErrorResponse(error, false);
      });
  };

  useEffect(() => {
    if (!serverData) {
      getSeoValuesData();
    }
  }, []);

  return (
    <>
      <Head>{seoValues && generateMetaData(seoValues)}</Head>
      <Root>
        <Box className={classes.bannerContainer}>
          <WelcomeBanner />
        </Box>
        <Box className={classes.pageContainer}>
          {/* <InsuranceInfo /> */}
          <HowRentingWorks />
          <QuestionsSection />
          <GotYourBack />
          <WhyEagleShare />
        </Box>
        <ReadyToEarn />
      </Root>
    </>
  );
};

export { RentMyMotorcycleView };
